<form nz-form [formGroup]="formGroup" (ngSubmit)="submit()">
  <div class="page-content-section">
    <fieldset>
      <legend>{{'Language Information' | translate}}</legend>
      <nz-form-item *ngIf="mode === 'edit'">
        <nz-form-label [nzSm]="24" [nzXs]="24" nzRequired [nzNoColon]="true" nzFor="Code">
          {{'Id'  | translate}}
        </nz-form-label>
        <nz-form-control [nzSm]="24" [nzXs]="24">
          <input nz-input formControlName="Id" id="Id" readonly />
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label [nzSm]="24" [nzXs]="24" nzRequired [nzNoColon]="true" nzFor="Isocode">
          {{'ISO Code'  | translate}}
        </nz-form-label>
        <nz-form-control [nzSm]="24" [nzXs]="24" [nzErrorTip]="'Please insert the iso code.'  | translate">
          <nz-select [nzAllowClear]="true" formControlName="Isocode" id="Isocode" nzShowSearch>
            <nz-option *ngFor="let lang of languages" [nzValue]="lang.Code"
              nzLabel="{{ lang.Label }} - {{ lang.Code }}"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label [nzSm]="24" [nzXs]="24" nzRequired [nzNoColon]="true" nzFor="Name">
          {{'Name'  | translate}}
        </nz-form-label>
        <nz-form-control [nzSm]="24" [nzXs]="24" [nzErrorTip]="'Please insert the language name.'  | translate">
          <input nz-input formControlName="Name" id="Name" />
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label [nzSm]="24" [nzXs]="24" nzRequired [nzNoColon]="true" nzFor="IsDefault">
          {{'Is Default Language'  | translate}}
        </nz-form-label>
        <nz-form-control [nzSm]="24" [nzXs]="24">
          <nz-select formControlName="IsDefault" id="IsDefault">
            <nz-option [nzLabel]="'Yes'  | translate | locale" [nzValue]="true"></nz-option>
            <nz-option [nzLabel]="'No' | translate | locale" [nzValue]="false"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </fieldset>
  </div>
  <input type="submit" style="display: none" />
</form>
